import { useSelector } from "react-redux";
import { useQuery } from "@apollo/client";
import { GET_CATEGORIES_IN_FOCUS } from "./categoriesInFocus.gql";

export const useCategoriesInFocus = () => {
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const categoryIds = ConfigData?.home_focus_categories?.split(",") || [];

  const { data } = useQuery(GET_CATEGORIES_IN_FOCUS, {
    skip: !categoryIds?.length,
    variables: { ids: categoryIds },
    context: { fetchOptions: { method: "GET" } },
  });

  return {
    categoriesInFocusData: data && data?.getMultipleCategories,
  };
};
